import { useEffect, useState } from "react";
import api from "../api";
import {
  IMPERIAL,
  METRIC,
  FAHRENHEIT,
  TEMP_UNIT_KEY,
  IMPERIAL_UNITS,
  METRIC_UNITS,
} from "../misc/constants";

export function useUnitSettings(userId) {
  const [unitSettings, setUnitSettings] = useState(IMPERIAL_UNITS);
  const [unitSystem, setUnitSystem] = useState(IMPERIAL);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/get_unit_settings/", {
          params: { user_id: userId },
        });
        if (!cancelled && data?.status === "success") {
          // Map backend fields into your constants
          const settings = {
            t2m_units: data.t2m_units,
            precipitation_units: data.precipitation_units,
            ws2m_units: data.ws2m_units,
          };
          // Choose a system constant (don’t mutate)
          if (settings[TEMP_UNIT_KEY] === FAHRENHEIT) {
            setUnitSystem(IMPERIAL);
            setUnitSettings(IMPERIAL_UNITS);
          } else {
            setUnitSystem(METRIC);
            setUnitSettings(METRIC_UNITS);
          }
        }
      } catch (_) {
        // fall back to defaults; no writes here
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [userId]);

  return { unitSettings, setUnitSettings, unitSystem, setUnitSystem };
}
